import React from "react";
import { useParams } from "react-router-dom";

import DetailPage from "../components/DetailPage";
import { getTechnology } from "../data/technologies";

function TechnologyDetail() {
  const { slug } = useParams();
  const tech = getTechnology(slug);

  return (
    <DetailPage
      item={tech}
      kind="TECHNOLOGY"
      backTo="/technology"
      backLabel="Back to Technology"
      notFoundTitle="Technology not found"
      notFoundText="The technology you're looking for doesn't exist."
      listTitle="Key Capabilities"
      listItems={tech?.features}
      useCases={tech?.useCases}
    />
  );
}

export default TechnologyDetail;
